<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <primary-filter
        :menuOptions="$checkMenuOptions(indentsMenu)"
        :selectedCategory="selectedCategory"
        :enableSearchPopup="true"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="actionButtons"
        :isUploading="isUploading"
        @searchByParameter="searchByParameter"
        @locationMilestoneUpload="locationMilestoneUpload"
        @consignmentBulkUpload="consignmentBulkUpload"
        @chargeableWeightBulkUpload="chargeableWeightBulkUpload"
        @lrUpload="lrUpload"
        @lrSampleFile="lrSampleFile"
        @rejectDownload="rejectDownload"
        @indentActionsUpload="indentActionsUpload"
        @indentActionsSampleDownload="indentActionsSampleDownload"
        @indentActionsRejectionDownload="indentActionsRejectionDownload"
        @bulkPodUpload="bulkPodUpload"
        @grnBulkUpload="grnBulkUpload"
        @grnSampleDownload="grnSampleDownload"

        />
    </portal>
    <div>
      <div class="flex-container page-filter">
        <div class="flex-item">
          <filter-wrapper
            :values="filterTags"
            @openSliderLeft="openSlideleft = !openSlideleft"/>
        </div>
    <div class="flex-item">
      <span>
        <Tooltip :open-delay="200" effect="dark" placement="left-start">
          <div slot="content"> {{ $t('INDENT_TRANSPORTER_SORTING_MESSAGE') }}</div>
          <svgicon name="icon-info-circle" width="14" height="14" :original="true" />
        </Tooltip>
      </span>
      <span class="mr-10"> {{ $t('RECENT_UPDATED') }}</span>
      <SwitchBtn v-model="isSorted" label="right" size="small" class="default-switch f-right"
       @change="indentSorted($event)">
      </SwitchBtn>
    </div>

      </div>
      <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div
              v-infinite-scroll="loadData"
              infinite-scroll-disabled="loadCheck"
              infinite-scroll-throttle-delay="400"
              infinite-scroll-distance="10">
              <indent-header
                :headers="getListHeaders"
                :noCheckbox="true" />
              <div v-if="isLoading" class="paymentloader"></div>
              <div v-else-if="indents.length === 0" class="emptydiv">
                <div class="paymentempty"></div>
                <div class="emptytext">{{$t('INDENTS_NO_INDENTS_FOUND')}}</div>
              </div>
              <div v-else>
                <indents-row v-for="(indent,index) in indents"
                  :key="index"
                  :sectionHeader="getListHeaders"
                  :indent="indent"
                  :depot_id="currentDepotId"
                  :isFilterClosed="!openSlideleft"
                  :configurations="configurations"
                  @show-details="showDetails"
                  @accept-indent="acceptIndent(indent.order_no)"
                  @show-actions="showActions"
                  @getPtl="getPtlGrouping"
                  @setGA="setGA" />
                <div v-if="isPaginating">
                  <Spinner />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <sec-filter
            v-if="filterConstant.length"
            :selectedFilters="filterConstant"
            :selectedDateFilter="selectedDateFilter"
            :filters="filters"
            @search="search"
            @updateOption="updateOption"
             @updateRadio="updateRadio"
            @reset="resetApply"
            @clearDate="clearDate" />
        </div>
        <div>
          <drawer
            :visible.sync="isDetailsEnabled"
            direction="rtl"
            size="750px"
            :modal="true"
            :withHeader="false"
            :append-to-body="true"
            class="default-drawer">
            <Link :underline="false" class="nav-close" @click="isDetailsEnabled=false">
              <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <indents-actions
              v-if="isDetailsEnabled"
              :indent="selectedIndent"
              :activeTab="activeTab"
              :action="action"
              @acceptIndent="acceptIndent"
              @rejectIndent="rejectIndent"
              @cancelAction="closeSlider"
              @updateTruck="updateTruck"
              @updateTruckType="updateTruckType"
              @updateLR="updateLR"
              @markDeliver="markDeliver"
              @updateHillyRegion="updateHillyRegion"
              @truck-in="truckIn"
              @truck-out="truckOut"
              @confirm-booking="confirmBooking"
              @containerPickup="containerPickup"
              @acceptTruckInspection="acceptTruckInspection"
              @rejectTruckInspection="rejectTruckInspection"
              :ptlGroups="ptlGroups"
              :isEligibleForPtlGrouping="isEligibleForPtlGrouping"
              :materialsInformation="materialsInformation" />
          </drawer>
        </div>
        <!-- Bulk POD Upload Slider -->
        <bulk-pod-upload
          :visible.sync="isBulkPodUploadVisible"
          @complete="onBulkPodUploadComplete" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomerfieldDefinition from 'customer-field-definitions';
import {
  indentsMenu,
  searchParameters,
  filters,
  indentsStatus,
  indentsHeader,
  buttonsList, uploadType, indentMovementTypes } from '@/constants/indentConstants';
import { deliveryTypes, utilizationStatus } from 'pando-constants';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import FilterWrapper from '@common/components/FilterWrapperV2';
import IndentHeader from '@common/components/HeaderV2';
import PrimaryFilter from '@/modules/common/PrimaryFilter';
import IndentsRow from '@/modules/indents/components/indentsRow';
import IndentsActions from '@/modules/indents/components/details/indentsActions';
import BulkPodUpload from '@/components/order/BulkPodUpload';

export default {
  components: {
    IndentHeader,
    SecFilter,
    FilterWrapper,
    PrimaryFilter,
    IndentsRow,
    IndentsActions,
    BulkPodUpload,
  },
  data() {
    return {
      indentsMenu,
      searchParameters,
      filters,
      indentsStatus,
      indentsHeader,
      buttonsList,
      transactionIds: [],
      rejectCount: 0,
      openSlideleft: false,
      defaultValues: {},
      filterConstant: [],
      loadCheck: true,
      searchedParams: {},
      isDetailsEnabled: false,
      selectedIndent: null,
      activeTab: '',
      currentDepotId: '',
      action: '',
      indentStatusList: [],
      section: '',
      CustomerfieldDefinition,
      indentMovementTypes,
      utilizationStatus,
      deliveryTypes,
      ptlGroups: [],
      isEligibleForPtlGrouping: false,
      materialsInformation: {},
      isSorted: true,
      isBulkPodUploadVisible: false,
    };
  },
  mixins: [SecFilterMixin],
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      indents: 'indents/list',
      filter: 'indents/filter',
      hasEmpty: 'indents/hasEmpty',
      isLoading: 'indents/isLoading',
      isPaginating: 'indents/isPaginating',
      configurations: 'app/currentClientConfig',
      parentList: 'indents/parentList',
      isUploading: 'indents/isUploading',
      bootstrap: 'app/data',
      otherDepots: 'app/getOtherDepots',
    }),
    isLastMileEnabled() {
      return this.$hasFeature('last_mile');
    },
    getListHeaders() {
      const strategy = (this.configurations.custom_view_strategy) ?
        this.configurations.custom_view_strategy :
        0;
      return this.CustomerfieldDefinition[strategy]['transporter-indent-listing'];
    },
    selectedCategory() {
      return this.indentsMenu.find(menu => menu.id === 'indents');
    },
    actionButtons() {
      const buttonList =
        this.buttonsList &&
        this.buttonsList.map((val) => {
          const button = val;
          if (button.id === 'reject_list') {
            if (this.rejectCount > 0) {
              button.show = true;
            } else {
              button.show = false;
            }
          } else if (button.name === 'Upload') {
            button.dropdownList = button.dropdownList.reduce((acc, current) => {
              if (current.feature) {
                if (this.$hasFeature(current.feature)) {
                  acc.push(current);
                }
              } else {
                acc.push(current);
              }
              return acc;
            }, []);
          }
          if (button.config) {
            const currentClientConfig = this.bootstrap && this.bootstrap.client_config && this.bootstrap.client_config[0];
            button.show = currentClientConfig[button.config] || false;
          }
          if (button.feature) {
            button.show = this.$hasFeature(button.feature);
          }
          // Check permission if both feature and permission are set
          if (button.feature && button.permission) {
            const hasPermission = Array.isArray(button.permission)
              ? button.permission.some(p => this.$hasPermission(p))
              : this.$hasPermission(button.permission);
            button.show = button.show && hasPermission;
          }
          return button;
        });
      return buttonList;
    },
  },
  async created() {
    await this.$store.dispatch('app/mdmBootstrap');
    this.indentStatusList = this.indentsStatus.filter((status) => {
      if (status.feature) {
        return this.$hasFeature(status.feature);
      }
      return true;
    });
    if (this.$hasFeature('transporter_delivery_pending_status')) {
      this.indentStatusList = this.indentStatusList.map(status =>
        (status.status_id === 23
          ? { ...status, name: 'Delivery Pending', tlabel: 'INDENT_DELIVERY_PENDING_STATUS' }
          : status));
      const deliveryPendingIdx = this.indentStatusList.findIndex(s => s.status_id === 23);
      if (deliveryPendingIdx !== -1 && !this.indentStatusList.some(s => s.status_id === 7)) {
        this.indentStatusList.splice(deliveryPendingIdx, 0, {
          id: 7, status_id: 7, name: 'Delivered', color: 'green', tlabel: 'INDENT_DELIVERED_STATUS',
        });
      }
    }
    this.setDefaults();
    this.loadFilters();
    this.$store.commit('indents/initialReset');
    this.loadSearchFromSession();
    this.search();
  },
  methods: {
    isVahanEnabledForDeliveryType() {
      const isFTL = this.selectedIndent && this.selectedIndent.vehicleType &&
        this.selectedIndent.vehicleType.vehicle_type === this.deliveryTypes.FTL;
      const hasNewFlags = this.$hasFeature('vahan_validation_ftl') || this.$hasFeature('vahan_validation_ptl');
      if (hasNewFlags) {
        return isFTL ? this.$hasFeature('vahan_validation_ftl') : this.$hasFeature('vahan_validation_ptl');
      }
      return this.$hasFeature('vahan_validation');
    },
    indentSorted($event) {
      this.isSorted = $event;
      this.search();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    setDefaults() {
      this.currentDepotId = this.depots[0];
      this.defaultValues.depot = [];
      this.defaultValues.depot.push(this.depots[0] || this.otherDepots[0]);
      this.defaultValues.gate = this.defaultValues.depot[0].gates || [];
      this.defaultValues.status = this.indentStatusList;
      this.defaultValues.movement = this.indentMovementTypes[0];
      this.defaultValues.startDate = null;
      this.defaultValues.endDate = null;
      this.defaultValues.show_epod_rejected = false;
    },
    constructConstantForFilter() {
      const depotList = this.constructDepotGroup(this.depots, this.otherDepots,
        this.defaultValues.depot.map(depot => depot.id));
      this.filterConstant = [
        [
          {
            type: 'MultiSelectGroup',
            category: this.filters.DEPOT,
            tlabel: 'INDENT_DEPOT',
            default: [depotList[0].options[0]],
            selected: [depotList[0].options[0]],
            list: depotList,
            idLabel: 'id',
            optional: false,
            allowEmpty: false,
            selectAllOption: true,
            queryParamString: 'depot_ids',
            placeholder: this.$t('DATE_ROLL_TABLE_SELECT_DEPOT'),
            search: true,
          },
          {
            type: 'MultiSelectList',
            category: this.filters.GATE,
            tlabel: 'INDENT_GATE',
            default: this.defaultValues.gate,
            selected: this.defaultValues.gate,
            list: this.defaultValues.gate,
            idLabel: 'id',
            optional: false,
            allowEmpty: false,
            selectAllOption: true,
            queryParamString: 'gate_ids',
            placeholder: this.$t('INDENT_SELECT_GATES'),
            defaultSelectAll: true,
            search: true,
          },
        ],
        [
          {
            type: 'DatePicker',
            category: this.filters.DATE_PICKER,
            tlabel: 'INDENT_DATE_FILTER',
            radioOptions: [
              {
                displayLabel: this.filters.CREATION_DATE,
                paramKey: 'creation',
              },
              {
                displayLabel: this.filters.VEH_DATE,
                paramKey: 'vehicle',
              },
              {
                displayLabel: this.filters.EDD_DATE,
                paramKey: 'edd',
              },
            ],
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            optional: true,
            start_date_label: 'start',
            end_date_label: 'end',
          },
          {
            type: 'MultiSelectList',
            category: this.filters.STATUS,
            tlabel: 'INDENT_STATUS',
            default: this.defaultValues.status,
            selected: this.defaultValues.status,
            list: this.indentStatusList,
            idLabel: 'id',
            optional: false,
            allowEmpty: false,
            queryParamString: 'status',
            placeholder: 'Select status',
            search: true,
          },
        ],
        [
          {
            type: 'List',
            category: this.filters.MOVEMENT,
            tlabel: 'INDENT_MOVEMENT',
            default: this.defaultValues.movement,
            selected: this.defaultValues.movement,
            list: this.indentMovementTypes,
            idLabel: 'id',
            queryParamString: 'movement',
          },
        ],
      ];
      if (this.$hasFeature('show_epod_rejected_indents_filter')) {
        this.filterConstant.push([
          {
            type: 'Toggle',
            category: this.filters.SHOW_EPOD_REJECTED,
            tlabel: 'SHOW_EPOD_REJECTED_INDENTS',
            default: this.defaultValues.show_epod_rejected,
            selected: this.defaultValues.show_epod_rejected,
            queryParamString: 'show_epod_rejected',
            feature: 'show_epod_rejected_indents_filter',
          },
        ]);
      }
    },
    resetApply() {
      this.$store.commit('indents/resetParentList');
      this.$store.commit('indents/setPage', 1);
      this.selectedDateFilter = 'creation';
      this.resetAll();
      this.search();
    },
    search() {
      this.$store.commit('indents/resetParentList');
      this.$store.commit('indents/setPage', 1);
      this.applyFilters();
      this.openSlideleft = false;
      this.loadData();
    },
    searchByParameter(params) {
      this.searchedParams = params;
      this.$store.commit('indents/resetParentList');
      this.$store.commit('indents/setPage', 1);
      this.saveSearchToSession();
      this.loadData();
    },
    async loadData() {
      try {
        if ((this.depots && this.depots.length > 0) ||
             (this.otherDepots && this.otherDepots.length)) {
          let filter = this.constructFilterPayload();
          if (filter) {
            if (filter.status) {
              filter.status = filter.status.split(',').map(Number);
            }
            filter = Object.assign(filter, this.filter);
            if (this.searchedParams && Object.keys(this.searchedParams).length) {
              Object.assign(filter, { ...this.searchedParams });
            }
            if (!this.$hasFeature('transporter_delivery_pending_status')
              && filter.status === this.$statusUtil.getStatusId('delivered')) {
              filter.status = this.$statusUtil.getStatusId('delivery_pending');
            }
            if (this.isSorted) {
              filter.is_sort = true;
            } else {
              filter.is_sort = false;
            }
            this.currentDepotId = filter.depot_id;
            const result = await this.$store.dispatch('indents/filter', filter);
            if (result.error) {
              this.$errorMessage({ message: result.error });
            }
            this.loadCheck = this.hasEmpty;
          }
        } else {
          this.$errorMessage({ message: this.$getErr('FEILDS_MISSING') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    openSlider(tab) {
      this.isDetailsEnabled = true;
      this.activeTab = tab;
    },
    closeSlider() {
      this.isDetailsEnabled = false;
    },
    async setSelectedIndent(orderNo, tab, isReturnIndent, hasChildIndents, action) {
      try {
        const result = await this.$store.dispatch('indents/getIndentDetails', { orderNo });
        if (result.data) {
          this.selectedIndent = result.data;
          this.selectedIndent.isReturnIndent = isReturnIndent;
          this.selectedIndent.isRoundTrip = !!hasChildIndents;
          this.action = action;
          this.openSlider(tab);
        }
        return result;
      } catch (error) {
        return error;
      }
    },
    showDetails(orderNo, isReturnIndent, hasChildIndents) {
      this.setSelectedIndent(orderNo, 'details', isReturnIndent, hasChildIndents);
    },
    async showActions(orderNo, isReturnIndent, hasChildIndents, action) {
      await this.setSelectedIndent(orderNo, 'actions', isReturnIndent, hasChildIndents, action);
    },
    async acceptIndent(orderNo) {
      try {
        const result = await this.$store.dispatch('indents/accept', { orderNo });
        if (result.data) {
          this.$successMessage({ message: this.$getSuccess('INDENT_ACCEPTED') });
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        return error;
      }
    },
    async rejectIndent(payload) {
      try {
        let orderNumbers = [];
        // ptl grouping
        if (this.isEligibleForPtlGrouping) {
          orderNumbers = this.ptlGroups.map(groupedData => groupedData.orderData
            .map(order => order.order_no.trim())).flat(1);
        }
        const data = {
          comments: payload.comments.trim(),
          orderNumbers,
          ...(payload.freight_rate) ? { freight_rate: payload.freight_rate } : {},
          ...(payload.freight_unit) ? { freight_unit: payload.freight_unit } : {},
        };
        const result = await this.$store.dispatch('indents/reject', {
          orderNo: this.selectedIndent.order_no, data, ptlGroupId: this.selectedIndent.ptl_group_id });
        if (result.data) {
          this.$successMessage({ message: this.$getSuccess('INDENT_REJECTED') });
          this.closeSlider();
        }
        if (result && result.message && result.message === 'PTL_GROUP_ACTION_PROGRESS') {
          this.$successMessage({ message: this.$t(result.message) });
          if (!this.isVahanEnabledForDeliveryType()) {
            this.$warningMessage({ message: 'Vahan/Sarathi validation was bypassed for orders in this PTL group' });
          }
          this.closeSlider();
          this.pollPtlGroupStatus(result.ptlGroupId, 'reject');
        } else if (result && result.message) {
          this.$error({ message: this.$t(result.message) });
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        return error;
      }
    },
    pollPtlGroupStatus(ptlGroupId, type) {
      const timer = setInterval(async () => {
        const status = await this.$store.dispatch('indents/ptlGroupActionStatus', { ptlGroupId, type });
        if (status === 'COMPLETED') {
          clearInterval(timer);
          this.$successMessage({ message: this.$getSuccess('INDENT_REJECTED') });
          this.$store.commit('indents/resetParentList');
          this.$store.commit('indents/setPage', 1);
          this.loadData();
        } else if (status === 'FAILED') {
          clearInterval(timer);
          this.$errorMessage({ message: 'PTL group action failed' });
          this.$store.commit('indents/resetParentList');
          this.$store.commit('indents/setPage', 1);
          this.loadData();
        }
      }, 1000);
    },
    async updateTruck(data, inspectionDataAndId = null) {
      try {
        const result = await this.$store.dispatch('indents/updateTruck', {
          orderNo: this.selectedIndent.order_no, data, ptlGroupId: this.selectedIndent.ptl_group_id });
        if (inspectionDataAndId && inspectionDataAndId.inspectionData && this.isVahanEnabledForDeliveryType()) {
          const { id, inspectionData } = inspectionDataAndId;
          await this.acceptTruckInspection({ id, data: inspectionData }, true);
        }
        if (result && result.data) {
          if (result.data.error) {
            this.$error({ message: result.data.error });
          } else if (result && result.data && result.data.order_no) {
            this.$successMessage({ message: this.$t('INDENT_VEHICLE_ASSIGNMENT_TOAST_MSG', { order_number: result.data.order_no }) });
            this.closeSlider();
          }
        } else if (result && result.message && result.message === 'PTL_GROUP_ACTION_PROGRESS') {
          this.closeSlider();
          this.$successMessage({ message: this.$t(result.message) });
          if (!this.isVahanEnabledForDeliveryType()) {
            this.$warning({ message: 'Vahan/Sarathi validation was bypassed for orders in this PTL group' });
          }
        } else if (result && result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        return error;
      }
    },
    async updateTruckType(data) {
      try {
        const result = await this.$store.dispatch('indents/updateTruckType', {
          orderNo: this.selectedIndent.order_no, data });
        if (result.data) {
          this.$successMessage({ message: this.$getSuccess('CHANGE_REQUESTED') });
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        return error;
      }
    },
    async updateLR(data) {
      try {
        const result = await this.$store.dispatch('indents/updateLR', {
          orderNo: this.selectedIndent.order_no, data });
        if (result.data) {
          this.$successMessage({ message: this.$t('INDENT_LR_NUMBER_TOAST_MSG') });
          this.closeSlider();
        }
        return result;
      } catch (error) {
        return error;
      }
    },

    setGA(name, action, label) {
      const depot = this.findByCategory(this.filters.DEPOT) || {};
      this.$addGAEvent('Transporter - Indent Management', action, `Transporter ${name}:${label}`,
        depot.name);
    },

    async markDeliver(data) {
      try {
        let payload = data;
        if (this.isLastMileEnabled) {
          payload = [];
          for (const destination of data) {
            if (destination.data) {
              delete destination.data.unloading_start_at;
              delete destination.data.unloading_end_at;
              payload.push(destination.data);
            }
          }
        }
        const result = await this.$store.dispatch('indents/deliver', {
          orderNo: this.selectedIndent.order_no, data: payload });
        if (!result) {
          this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
        }
        if (result.data) {
          if (this.isLastMileEnabled) {
            const name = (data[0] && data[0].name) || '';
            if (payload[0].is_not_delivered) {
              this.$successMessage({
                message: this.$t('LAST_MILE_NOT_DELIVERED_MSSG', { consignee_name: name, order_number: result.data.order_no }),
              });
            } else {
              this.$successMessage({ message: this.$t('LAST_MILE_DROP_COMPLETED_MSSG',
                { order_number: result.data.order_no, consignee_name: name }) });
            }
          } else {
            this.$successMessage({ message: this.$t('INDENT_MARK_AS_DELIVERED_TOAST_MSG',
              { order_number: result.data.order_no }) });
          }
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },

    async updateHillyRegion(data) {
      try {
        const result = await this.$store.dispatch('indents/updateHillyRegion', {
          orderNo: this.selectedIndent.order_no, data });
        if (result.data) {
          this.$successMessage({ message: this.$getSuccess('CHANGE_REQUESTED') });
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },

    async truckIn(data) {
      try {
        const result = await this.$store.dispatch('indents/truckIn', {
          orderNo: this.selectedIndent.order_no, data });
        if (!result) {
          this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
        }
        if (result.data) {
          this.$successMessage({ message: this.$t('INDENT_TRUCK_IN_TOAST_MSG', { order_number: result.data.order_no }) });
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },

    async containerPickup(data) {
      try {
        const result = await this.$store.dispatch('indents/containerPickup', {
          orderNo: this.selectedIndent.order_no, data });
        if (!result) {
          this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
        }
        if (result.data) {
          this.$successMessage({ message: this.$getSuccess('CONTAINER_PICKUP_SUCCESS') });
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async confirmBooking(bookingNumber) {
      try {
        const result = await this.$store.dispatch('indents/confirmBooking', {
          orderNo: this.selectedIndent.order_no,
          bookingNumber: bookingNumber || '',
        });
        if (!result) {
          this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
        }
        if (result.data) {
          this.$successMessage({ message: this.$getSuccess('INDENT_BOOKING_CONFIRMED') });
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async truckOut(data) {
      try {
        let payload = data;
        if (this.isLastMileEnabled) {
          payload = payload.data;
        }
        const result = await this.$store.dispatch('indents/truckOut', {
          orderNo: this.selectedIndent.order_no,
          data: payload });
        if (!result) {
          this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
        }
        if (result.data) {
          if (this.isLastMileEnabled) {
            this.$successMessage({ message: this.$t('LAST_MILE_PICKUP_COMPLETED_MSSG',
              { order_number: result.data.order_no, consignee_name: data.name }) });
          } else if (this.utilizationStatus.APPROVED === result.data.approval_status) {
            this.$successMessage({ message: this.$t('INDENT_TRUCK_OUT_TOAST_MSG',
              { order_number: result.data.order_no }) });
          }
          this.closeSlider();
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async acceptTruckInspection({ id, data }, isVehicleInspectionAtSource = true) {
      try {
        delete data.accepted;
        let result;
        if (isVehicleInspectionAtSource) {
          result = await this.$store.dispatch('indents/inspection', { id, data });
        } else {
          result = await this.$store.dispatch('indents/inspectionAtDestination', { id, data });
        }
        if (result.order_number) {
          this.$success({ message: this.$t('INDENT_INSPECTION_ACCEPTANCE_TOAST_MSG', { order_number: result.order_number }) });
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async rejectDownload() {
      let result;
      if (this.section === uploadType.LOCATION_MILESTONE_UPLOAD) {
        result = await this.$store.dispatch('indents/locationMilestoneDownloadInvalid', {
          transactionId: this.transactionIds.join(','),
        });
      } else if (this.section === uploadType.CHARGEABLE_WEIGHT_BULK_UPLOAD) {
        result = await this.$store.dispatch('indents/chargeableWeightDownloadInvalid', {
          transactionId: this.transactionIds.join(','),
        });
      } else if (this.section === uploadType.LR_UPLOAD) {
        result = await this.$store.dispatch('indents/lrDownloadInvalid', {
          transactionId: this.transactionIds.join(','),
        });
      } else if (this.section === uploadType.INDENT_ACTIONS_UPLOAD) {
        result = await this.$store.dispatch('indents/indentActionsRejectionDownload', {
          transactionId: this.transactionIds[0],
        });
      } else if (this.section === uploadType.GRN_BULK_UPLOAD) {
        result = await this.$store.dispatch('indents/grnDownloadInvalid', {
          transactionId: this.transactionIds.join(','),
        });
      } else {
        result = await this.$store.dispatch('indents/consignmentDownloadInvalid', {
          transactionId: this.transactionIds.join(','),
        });
      }
      if (result && result === 'email') {
        this.$infoMessage({ message: this.$getSuccess('EXPORT_VIA_EMAIL') });
      }
    },
    async uploadStatus(data) {
      const result = await this.$store.dispatch('indents/locationMilestoneUploadStatus', {
        key: data,
      });
      if (result.code === 'COMPLETED') {
        this.$store.commit('indents/setuploadStatus', false);
        this.transactionIds = [result.transaction_id];
        this.rejectCount = result.invalid_count;
        if (this.rejectCount === 0) {
          this.$successMessage({ message: 'All records are uploaded successfully' });
        } else {
          this.$successMessage({
            message: `${this.rejectCount} invalid records out of ${result.valid_count + this.rejectCount} records`,
          });
        }
        this.loadData();
      } else if (result.code === 'FAILED') {
        this.$store.commit('indents/setuploadStatus', false);
        this.timerTask = 0;
        this.$errorMessage({ message: 'Upload Failed' });
        this.loadData();
      } else if (result.code === 'PROGRESS') {
        await this.uploadStatus();
      }
    },

    async lrUploadStatus(data) {
      const result = await this.$store.dispatch('indents/lrBulkUploadStatus', {
        key: data,
      });
      if (result.code === 'COMPLETED') {
        this.$store.commit('indents/setuploadStatus', false);
        this.transactionIds = [result.transaction_ids];
        this.rejectCount = result.invalid_count;
        if (this.rejectCount === 0) {
          this.$successMessage({ message: 'All records are uploaded successfully' });
        } else {
          this.$successMessage({
            message: `${this.rejectCount} invalid records out of ${result.valid_count + this.rejectCount} records`,
          });
        }
        this.loadData();
      } else if (result.code === 'FAILED') {
        this.$store.commit('indents/setuploadStatus', false);
        this.timerTask = 0;
        this.$errorMessage({ message: 'Upload Failed' });
        this.loadData();
      } else if (result.code === 'PROGRESS') {
        await this.lrUploadStatus();
      }
    },

    async consignmentUploadStatus(data) {
      const result = await this.$store.dispatch('indents/consignmentUploadStatus', {
        key: data,
      });
      if (result.code === 'COMPLETED') {
        this.timerTask = 0;
        this.$store.commit('indents/setuploadStatus', false);
        this.transactionIds = result.transaction_ids;
        this.rejectCount = result.invalid_count;
        if (this.rejectCount === 0) {
          this.$successMessage({ message: 'All records are uploaded successfully' });
        } else {
          this.$successMessage({
            message: `${this.rejectCount} invalid records out of ${result.valid_count + this.rejectCount} records`,
          });
        }
        this.loadData();
      } else if (result.code === 'FAILED') {
        this.$store.commit('indents/setuploadStatus', false);
        this.timerTask = 0;
        this.$errorMessage({ message: 'Upload Failed' });
        this.loadData();
      }
    },
    async locationMilestoneUpload(file) {
      try {
        this.$store.commit('indents/setuploadStatus', true);
        this.section = uploadType.LOCATION_MILESTONE_UPLOAD;
        const formData = new FormData();
        formData.append('attachment', file);
        this.section = 'locationMilestoneUpload';
        const result = await this.$store.dispatch('indents/locationMilestoneUpload', { formData });
        if (result && result.data && result.data.errors) {
          this.$error({ message: result.data.errors[0].code });
        } else if (result && result.data) {
          this.$infoMessage({ message: result.data });
          if (result.status !== 400) await this.uploadStatus();
        } else {
          await this.uploadStatus();
        }
        this.$store.commit('indents/setuploadStatus', false);
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async consignmentBulkUpload(file) {
      try {
        this.$store.commit('indents/setuploadStatus', true);
        this.section = uploadType.CONSIGNMENT_BULK_UPLOAD;
        this.timerTask = 1000;
        const formData = new FormData();
        formData.append('attachment', file);
        const result = await this.$store.dispatch('indents/consignmentBulkUpload', { formData });
        if (result && result.data && result.data.errors) {
          this.$error({ message: result.data.errors[0].code });
        } else if (result.status !== 400) {
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.consignmentUploadStatus();
            }
          }, this.timerTask);
        } else {
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.consignmentUploadStatus();
            }
          }, this.timerTask);
        }
        this.$store.commit('indents/setuploadStatus', false);
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async chargeableWeightUploadStatus(data) {
      const result = await this.$store.dispatch('indents/chargeableWeightUploadStatus', {
        key: data,
      });
      if (result.code === 'COMPLETED') {
        this.timerTask = 0;
        this.$store.commit('indents/setuploadStatus', false);
        this.rejectCount = result.invalid_count;
        this.transactionIds = result.transactionIds;

        if (this.rejectCount === 0) {
          this.$successMessage({ message: 'All records are uploaded successfully' });
        } else {
          this.$successMessage({
            message: `${this.rejectCount} invalid records out of ${result.valid_count + this.rejectCount} records`,
          });
        }
        this.loadData();
      } else if (result.code === 'FAILED') {
        this.$store.commit('indents/setuploadStatus', false);
        this.timerTask = 0;
        this.$errorMessage({ message: 'Upload Failed' });
        this.loadData();
      }
    },
    async indentActionsUploadStatus() {
      const result = await this.$store.dispatch('indents/indentActionsUploadStatus', {
        transactionId: this.transactionIds[0],
      });
      if (result.status === 'COMPLETED') {
        this.timerTask = 0;
        this.$store.commit('indents/setuploadStatus', false);
        this.rejectCount = result.invalid_count;

        if (this.rejectCount === 0) {
          this.$successMessage({ message: 'All records are uploaded successfully' });
        } else {
          this.$successMessage({
            message: `${this.rejectCount} invalid records out of ${result.valid_count + this.rejectCount} records`,
          });
        }
        this.loadData();
      } else if (result.status === 'FAILED') {
        this.$store.commit('indents/setuploadStatus', false);
        this.timerTask = 0;
        this.$errorMessage({ message: 'Upload Failed' });
        this.loadData();
      }
    },
    async chargeableWeightBulkUpload(file) {
      try {
        this.$store.commit('indents/setuploadStatus', true);
        this.section = uploadType.CHARGEABLE_WEIGHT_BULK_UPLOAD;
        this.timerTask = 1000;
        const formData = new FormData();
        formData.append('attachment', file);
        const result = await this.$store.dispatch('indents/chargeableWeightBulkUpload', { formData });
        if (result && result.data && result.data.errors) {
          this.$error({ message: result.data.errors[0].code });
        } else if (result.status !== 400) {
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.chargeableWeightUploadStatus();
            }
          }, this.timerTask);
        } else {
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.chargeableWeightUploadStatus();
            }
          }, this.timerTask);
        }
        this.$store.commit('indents/setuploadStatus', false);
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async indentActionsUpload(file) {
      try {
        this.$store.commit('indents/setuploadStatus', true);
        this.section = uploadType.INDENT_ACTIONS_UPLOAD;
        this.timerTask = 1000;
        const formData = new FormData();
        formData.append('attachment', file);
        const result = await this.$store.dispatch('indents/indentActionsUpload', { formData });
        if (result && result.errors) {
          this.$error({ message: result.data.errors[0].code });
        } else if (result.transaction_id) {
          this.transactionIds = [result.transaction_id];
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.indentActionsUploadStatus();
            }
          }, this.timerTask);
        } else {
          this.$errorMessage({ message: 'Something went wrong. Please try again later' });
        }
        this.$store.commit('indents/setuploadStatus', false);
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    bulkPodUpload() {
      this.isBulkPodUploadVisible = true;
    },
    onBulkPodUploadComplete() {
      // Refresh order list after bulk POD upload completes
      this.search();
    },
    async lrUpload(file) {
      try {
        this.$store.commit('indents/setuploadStatus', true);
        this.section = uploadType.LR_UPLOAD;
        const formData = new FormData();
        formData.append('attachment', file);
        const result = await this.$store.dispatch('indents/lrBulkUpload', { formData });
        if (result && result.data && result.data.errors) {
          this.$error({ message: result.data.errors[0].code });
        } else if (result && result.data) {
          this.$infoMessage({ message: result.data });
          if (result.status !== 400) await this.uploadStatus();
        } else {
          await this.lrUploadStatus();
        }
        this.$store.commit('indents/setuploadStatus', false);
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async lrSampleFile() {
      try {
        await this.$store.dispatch('indents/downloadLrBulkSample');
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async indentActionsSampleDownload() {
      try {
        await this.$store.dispatch('indents/indentActionsSampleDownload');
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },

    async grnBulkUpload(file) {
      try {
        this.$store.commit('indents/setuploadStatus', true);
        this.section = uploadType.GRN_BULK_UPLOAD;
        const formData = new FormData();
        formData.append('attachment', file);
        const result = await this.$store.dispatch('indents/grnBulkUpload', { formData });
        if (result && result.data && result.data.errors) {
          this.$error({ message: result.data.errors[0].code || result.data.errors[0].message });
          this.$store.commit('indents/setuploadStatus', false);
        } else {
          // upload accepted (204) — the worker processes async; poll status until done.
          this.timerTask = 2000;
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.grnBulkUploadStatus(timer);
            }
          }, this.timerTask);
        }
        return result;
      } catch (error) {
        this.$store.commit('indents/setuploadStatus', false);
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },

    async grnSampleDownload() {
      try {
        return await this.$store.dispatch('indents/downloadGrnBulkSample');
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },

    async grnBulkUploadStatus(timer) {
      try {
        const result = await this.$store.dispatch('indents/grnBulkUploadStatus');
        if (result && result.code === 'COMPLETED') {
          if (timer) clearInterval(timer);
          this.timerTask = 0;
          this.$store.commit('indents/setuploadStatus', false);
          this.transactionIds = result.transaction_ids || (result.transaction_id ? [result.transaction_id] : []);
          this.rejectCount = result.invalid_count || 0;
          if (this.rejectCount === 0) {
            this.$successMessage({ message: 'All GRN records uploaded successfully' });
          } else {
            const totalRecords = result.valid_count + this.rejectCount;
            this.$errorMessage({
              message: `${this.rejectCount} invalid records out of ${totalRecords} records`,
            });
          }
          this.search();
        } else if (result && (result.code === 'UPLOAD_FAILED' || result.failed)) {
          if (timer) clearInterval(timer);
          this.timerTask = 0;
          this.$store.commit('indents/setuploadStatus', false);
          this.$errorMessage({ message: 'GRN upload failed' });
        }
        return result;
      } catch (error) {
        this.timerTask = 0;
        this.$store.commit('indents/setuploadStatus', false);
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async indentActionsRejectionDownload() {
      try {
        if (this.transactionIds && this.transactionIds[0]) {
          await this.$store.dispatch('indents/indentActionsRejectionDownload', {
            transactionId: this.transactionIds[0],
          });
        }
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async rejectTruckInspection({ id, data }) {
      try {
        const result = await this.$store.dispatch('indents/inspection', { id, data });
        if (result.order_number) {
          this.$success({ message: this.$t('INDENT_INSPECTION_ACCEPTANCE_TOAST_MSG', { order_number: result.order_number }) });
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: error.message || this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async getPtlGrouping({ order, actionName }) {
      this.isEligibleForPtlGrouping = order.vehicleType
      && order.vehicleType.vehicle_type === this.deliveryTypes.PTL
      && this.$hasFeature('ptl_grouping');
      if (this.isEligibleForPtlGrouping) {
        const result = await this.$store.dispatch('indents/isPtlGrouping', { orderNo: order.order_no });
        this.ptlGroups = (!result || result.error) ? [] : result;
        if (actionName !== 'INDENT_DETAILS') {
          this.currentSelectedTab = actionName && ([this.indentActions.ASSIGN_TRUCK, this.indentActions.UPDATE_TRUCK, this.indentActions.START_LOAD,
            this.indentActions.END_LOAD, this.indentActions.TRUCKIN, this.indentActions.TRUCKOUT].includes(actionName)) ? 'ptl_grouping' : 'actions';
        }
        const orderNos = this.ptlGroups ? this.ptlGroups.map(ptlGroup => ptlGroup.orderData.map(
          orderInfo => orderInfo.order_no)).flat(1) : [];
        const materialsInfoResult = await this.$store.dispatch('indents/calculateMaterialsLoad', { orderNos });
        if (materialsInfoResult && materialsInfoResult.data) {
          this.materialsInformation = materialsInfoResult.data;
        }
      }
    },
  },
};
</script>
